import { Injectable } from '@angular/core';
import { StorageService } from './storage-service';

@Injectable({
  providedIn: 'root'
})

/**
 * 用於設定
 */
export class MyConfigService {


  constructor(
    private storageService: StorageService
  ) {

  }

  async getSetting(): Promise<MySetting> {

    var data = await this.storageService.get("mySettings");

    if (!data) {
      //若無設定，設定初始值
      return (this.createDefaultValue());
    } else {
      return (JSON.parse(data));
    }

  }
  createDefaultValue(): MySetting {
    return { isSeedAns: false ,isAutoNext:false,remindTime:"",fontSizeHtml:12};
  }

  async setSetting(settedValue: MySetting) {

    await this.storageService.set("mySettings", JSON.stringify(settedValue));
  }
}

export class MySetting {
  isSeedAns: boolean;//是否要看答案
  isAutoNext: boolean;
  remindTime: string;
  fontSizeHtml:number;
}
